var defineWellKnownSymbol = require('../internals/define-well-known-symbol');

// `Symbol.toStringTag` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.tostringtag
defineWellKnownSymbol('toStringTag');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es.symbol.to-string-tag.js
// module id = 1302
// module chunks = 1